import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom"; // For navigation
import TableToExcel from "./helpers/Excel";
import { getFormattedDate } from "./helpers/functions";

const Notfilled = () => {
    const [data, setData] = useState([]);
   
    useEffect(() => {
        axios.post("api/getteachersdatanot")
            .then((res) => {
                setData(res.data.rows);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }, []);

   
    // Function to extract specific columns from the data
    const extractSpecificColumns = (data) => {
        return data.map((row) => {
            const { MosName, Semel, ty, Gender, Principal, Ptel, t_count } = row;
            return {
                "שם מוסד": MosName,
                "סמל": Semel,
                "עיר": ty,
                "מין": Gender,
                "מנהל": Principal,
                "טל": Ptel,
                "מס מורים":t_count
            };
        });
    };

    let specificColumnsData = extractSpecificColumns(data);
   
    return (
        <>
            <Container className='text-center'>
                <h3 className='pt-2'>
                    מוסדות שלא סיימו
                </h3>
                <hr />
                <Row className='mb-1'>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} >
                        <TableToExcel data={specificColumnsData} fileName={`data_${getFormattedDate()}`} />
                    </Col>
                </Row>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>שם מוסד</th>
                            <th>סמל</th>
                            <th>עיר</th>
                            <th>מין</th>
                            <th>מנהל</th>
                            <th>טל</th>
                            <th>מס מורים</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => {
                            return (
                                <tr key={index}>
                                    <td><Link to={"/teachersdata?semel="+row.Semel}>{row.MosName}</Link></td>
                                    <td>{row.Semel}</td>
                                    <td>{row.ty}</td>
                                    <td>{row.Gender}</td>
                                    <td>{row.Principal}</td>
                                    <td>{row.Ptel}</td>
                                    <td>{row.t_count}</td>
                                </tr>
                            )
                        }
                        )}
                    </tbody>
                </Table>
                </Container>
        </>
    );
};

export default Notfilled;
